import React from 'react';
import { Link } from 'react-router-dom';
import { Parallax } from 'react-scroll-parallax';

const AboutGastro = ( { wrapperClass  } ) => {
    return (
        <div className={`eduvibe-about-one-team home-three-about edu-about-area about-style-4 bg-image pt--45 ${ wrapperClass || 'edu-section-gapBottom' }`}>
            <div className="container eduvibe-animated-shape">
                <div className="row g-lg-5 g-md-5 g-sm-5">
                    <div className="col-lg-12 col-xl-6">
                        <div className="gallery-wrapper">
                            <img src="https://images.pexels.com/photos/28559514/pexels-photo-28559514/free-photo-of-inyenc-sajtos-martogatos-rusztikus-kornyezetben.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="About Images" />
                            <div className="image-2">
                                <Parallax y={[-25, 15]} tagOuter="figure">
                                    {/*<img src="https://images.pexels.com/photos/28513677/pexels-photo-28513677/free-photo-of-finom-reggeli-palacsintaval-es-kaveval.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="About Images" />*/}
                                </Parallax>
                            </div>
                            {/*<div className="image-3">*/}
                            {/*    <Parallax y={[40, -40]} tagOuter="figure">*/}
                            {/*        <img src="/favicon.png" alt="About Images" />*/}
                            {/*    </Parallax>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                        <div className="inner mt_mobile--40">
                            <div className="section-title text-start">
                                <span className="pre-title">Vendéglátósoktól Vendéglátósoknak</span>
                                <h3 className="title">Happy Gastro</h3>
                            </div>
                            <div className="feature-style-6 mt--40">
                                <div className="edu-feature-list color-variation-1">
                                    <div className="icon">
                                        <img src="/images/about/about-05/student.png" alt="Icons Images" />
                                    </div>
                                    <div className="content">
                                        <h6 className="title">Integrált és könnyen használható rendszer</h6>
                                        <p className="description">A Happy Gastro több szolgáltatással is összekapcsolható, mint például Foodora, Wolt, Számlázz.hu és Billingo, ezáltal egyszerűvé és hatékonnyá téve az online rendelési és fizetési folyamatokat. Emellett a rendszer távolról is hozzáférhető.</p>
                                    </div>
                                </div>

                                <div className="edu-feature-list color-variation-2">
                                    <div className="icon">
                                        <img src="/images/aboutgastro/delivery.png" alt="Icons Images" />
                                    </div>
                                    <div className="content">
                                        <h6 className="title">Hatékony házhozszállítás és rendeléskezelés</h6>
                                        <p className="description"> A futár modul nyomon követi a rendeléseket és optimalizálja az útvonalakat, így gyorsabb és precízebb szállítást biztosít. A mobil pincér funkció pedig gyorsabb kiszolgálást és pontosabb rendelések rögzítését teszi lehetővé tableten vagy okostelefonon.</p>
                                    </div>
                                </div>

                                <div className="edu-feature-list color-variation-3">
                                    <div className="icon">
                                        <img src="/images/about/about-05/reward.png" alt="Icons Images" />
                                    </div>
                                    <div className="content">
                                        <h6 className="title">Automatizált folyamatok a jobb vendégélményért</h6>
                                        <p className="description">A szoftver automatizálja az asztalfoglalásokat, készletkezelést és beszerzési folyamatokat, csökkentve az emberi hibákat és növelve a hatékonyságot. A digitális étlap és a KDS rendszer révén gyorsabb a kiszolgálás és kevesebb papírhulladék keletkezik.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="read-more-btn mt--30">
                            <Link className="edu-btn" to="/termekek/gastro">Bővebben <i className="icon-arrow-right-line-right"></i></Link>
                        </div>
                    </div>
                </div>

                <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-03-08.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-27.png" alt="Shape Thumb" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutGastro;